@if (label(); as labelText) {
  <span [id]="labelId" class="mb-2 block text-sm font-medium text-slate-500">{{ labelText }}</span>
}

<div class="flex items-center gap-3">
  <div
    class="focus-visible:ring-primary-300/50 relative h-6 min-w-0 flex-1 touch-none rounded-full outline-none select-none focus-visible:ring-2"
    [class.cursor-pointer]="!disabled()"
    [class.cursor-not-allowed]="disabled()"
    [class.opacity-40]="disabled()"
    role="slider"
    aria-orientation="horizontal"
    [attr.tabindex]="disabled() ? -1 : 0"
    [attr.aria-labelledby]="label() ? labelId : null"
    [attr.aria-label]="!label() ? ariaLabel() : null"
    [attr.aria-valuemin]="domainMin()"
    [attr.aria-valuemax]="domainMax()"
    [attr.aria-valuenow]="value()"
    [attr.aria-valuetext]="valueText()"
    [attr.aria-disabled]="disabled() || null"
    (pointerdown)="onTrackPointerDown($event)"
    (keydown)="onKeyDown($event)"
  >
    <div aria-hidden="true" class="absolute top-1/2 h-1.5 w-full -translate-y-1/2 rounded-full bg-slate-100"></div>
    <div
      aria-hidden="true"
      class="bg-primary-500 absolute top-1/2 h-1.5 -translate-y-1/2 rounded-full motion-reduce:transition-none!"
      [style.transition]="dragging() && !animatePositionWhileDragging() ? 'none' : 'width 100ms'"
      [style.width.%]="thumbPercent()"
    ></div>

    @for (mark of markPercents(); track mark) {
      <div
        aria-hidden="true"
        class="pointer-events-none absolute top-1/2 size-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white ring-1 ring-slate-300"
        [style.left.%]="mark"
      ></div>
    }

    <div
      aria-hidden="true"
      class="bg-primary-500 absolute top-1/2 size-5 -translate-x-1/2 -translate-y-1/2 rounded-full shadow-sm ring-2 ring-white motion-reduce:transition-none!"
      [class.scale-125]="dragging()"
      [style.transition]="(dragging() && !animatePositionWhileDragging() ? '' : 'left 100ms, ') + 'transform 150ms ease-out'"
      [style.left.%]="thumbPercent()"
    ></div>
  </div>

  <div class="ml-3 flex shrink-0 items-center gap-2">
    <input
      type="number"
      class="w-16 shrink-0 rounded-xl border border-slate-200 bg-white px-2 py-1 text-center text-sm font-medium text-slate-900 outline-none focus-visible:ring-2 focus-visible:ring-slate-900/20 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-300"
      [attr.min]="min()"
      [attr.max]="max()"
      [attr.step]="step()"
      [attr.aria-labelledby]="label() ? labelId : null"
      [attr.aria-label]="!label() ? ariaLabel() : null"
      [disabled]="disabled()"
      [value]="value()"
      (change)="onNumberInput($event)"
    />

    @if (unit(); as unitLabel) {
      <span class="shrink-0 text-sm text-slate-500">{{ unitLabel }}</span>
    }
  </div>
</div>
